import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

import { api } from "@/lib/api";

import { type Mood } from "../types";

export type MoodList = Mood<true>[];

export const mood = createQueryKeys("mood", {
  all: null,
});

const include = "reasons";

export const fetchMoodsQueryOptions = () =>
  queryOptions({
    ...mood.all,
    queryFn: () =>
      api
        .get<MoodList>(`/mood?include=${include}`, {
          params: { include },
        })
        .then((response) => response.data),
  });

export const useFetchMoods = () => useQuery(fetchMoodsQueryOptions());

export interface MoodUserRequest {
  mood_id: number;
  reasons: number[];
}

export const useCreateMoodUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: MoodUserRequest) =>
      api
        .put(`/mood?include=${include}`, data)
        .then((response) => response.data),
    onSuccess: () => {
      queryClient.removeQueries(mood.all);
    },
  });
};
